import { docReady } from "../utilities";

docReady(function() {
  // DOM is loaded and ready for manipulation here
  var menus = document.getElementsByClassName("footer__menu-title");
  var i;

  for (i = 0; i < menus.length; i++) {
    menus[i].addEventListener("click", function event(e) {
      if (window.innerWidth < 992) {
        e.preventDefault();
        this.parentElement.classList.toggle("footer__section--open");
      }
    });
  }
  //Save the id of the submitted form, to set focus back after google recatpcha page is displayed
  const footerNewsletterForm = document.getElementById('customer-newsletter');
  if (footerNewsletterForm) {
    footerNewsletterForm.addEventListener('submit', function(event) {
        if (localStorage) {
            localStorage.setItem('submittedFormID', 'customer-newsletter');
        }
    })
  }
  let urlchecked = 0;
  function checkFormUrl() {
    urlchecked +=1;
    if (location.href.indexOf('customer_posted=') > -1 || location.href.indexOf('contact%5Btags%5D=newsletter&form_type=customer') > -1) {
        if (localStorage) {            
            const formSubmittedID = localStorage.getItem('submittedFormID');
            if (formSubmittedID) {
                const formSubmitted = document.getElementById(formSubmittedID);
                if (formSubmitted) {
                    window.scrollTo(0, formSubmitted.getBoundingClientRect().top);
                    if (location.href.indexOf('customer_posted=') < 0) {
                        formSubmitted.innerHTML = '<div>Thanks for subscribing</div>';
                    }
                    if (urlchecked >= 2) {
                        localStorage.removeItem('submittedFormID');
                    }
                }
            }
        }
    }
  }
  checkFormUrl();
  window.addEventListener('load', function() {
    setTimeout(function() {checkFormUrl()}, 500);
  });
});
